import { CreateAssetLocation } from "@/components/installFlowV2/create-asset-location";
import { isAuthenticated } from "@/auth";
import { createFileRoute, redirect } from "@tanstack/react-router";
import { z } from "zod";
import { apiClient } from "@/api/client";
import { installFlowOrganizationId } from "@/installFlow/storage-keys";

async function validateInstallFlowOrgId(): Promise<number | null> {
  const raw = installFlowOrganizationId.get();
  const id = raw ? Number(raw) : NaN;
  if (!raw || isNaN(id) || id <= 0) return null;
  try {
    await apiClient.get(`/organizations/${id}/?minimal=True`);
    return id;
  } catch {
    return null;
  }
}

export const Route = createFileRoute("/installFlow/create-asset-location")({
  component: CreateAssetLocation,
  validateSearch: z.object({
    redirect: z.string().optional().catch(""),
  }),
  beforeLoad: async ({ search }) => {
    const authenticated = isAuthenticated();
    if (!authenticated) {
      throw redirect({ to: "/login" });
    }
    const orgId = await validateInstallFlowOrgId();
    if (orgId === null) {
      throw redirect({ to: "/installFlow/select-organization" });
    }
  },
});
